<template>
  <div class="root" style="min-height: 555px">
    <p class="mode">
      <span>招投标</span>
      <!-- <router-link :to="{ name: '资产招商', query: { dm: deptId } }">更多></router-link> -->
    </p>
    <div
      v-for="(item, index) in xiangmuList"
      :key="index"
      class="xiangmu"
      @click="toxiangmu(item ? item.id : '')"
    >
      <el-carousel height="220px" indicator-position="none">
        <el-carousel-item v-for="(item1, index) in item.imgList" :key="index">
          <el-image :src="item1" style="height: 220px; width: 100%"></el-image>
        </el-carousel-item>
      </el-carousel>
      <div class="xiang-status">
        {{ Number(item.status) > 6 ? "已结束" : statusList[item.status] }}
      </div>
      <div class="main-content">
        <div class="xiang-title">{{ item.areaName + item.projectname }}</div>
        <!-- <div class="xiang-content">采购方：<span> {{ item.tendername }}</span></div> -->
        <div class="xiang-content">
          <img src="@/assets/img/卡片图标1.png" />挂牌价格：<span
            class="price-year"
          >
            {{ item.price }}{{ priceUnitList[item.areaUnit] }}</span
          >
        </div>
        <!-- <div class="xiang-content">预算金额：<span class="price-year"> {{ item.price }}</span>元</div> -->
        <div class="xiang-content">
          <img src="@/assets/img/卡片图标2.png" />流转面积：<span>
            {{ item.area }}</span
          >{{ unitList[item.areaUnit] }}
        </div>
        <!-- <div class="xiang-content">采购代理机构：<span> {{ item.agentname }}</span></div> -->
        <div class="xiang-content">
          <img src="@/assets/img/卡片图标4.png" />转出方：<span>
            {{ item.outname }}</span
          >
        </div>
        <!-- <div class="xiang-content">招标文件领取结束时间:<span> {{ item.getstoptime }}</span></div> -->
        <div class="xiang-content">
          <img src="@/assets/img/卡片图标3.png" />报名截止时间：<span>
            {{ item.releaseRecord.applyStopTime }}</span
          >
        </div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 20px;
          padding: 10px 0;
          box-sizing: border-box;
          border-top: 1px solid #ddd;
          color: #999;
        "
      >
        <div style="border-right: 1px solid #ddd; flex: 1; text-align: center">
          <span>浏览次数：{{ item.watchCts ? item.watchCts : "0" }} 次</span>
        </div>
        <div
          style="flex: 1; text-align: center"
          v-if="!cityDetail.notShowWatchNum"
        >
          <span>报名人数：{{ item.signCts ? item.signCts : "0" }} 人</span>
        </div>
      </div>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: end"
      v-if="xiangmuList.length"
    >
      <el-pagination
        layout="prev, pager, next, total"
        :total="listTotal"
        @prev-click="prevClick"
        @next-click="nextClick"
        @current-change="currentChange"
        :page-size="8"
      >
      </el-pagination>
    </div>
    <h1 v-if="!xiangmuList.length" style="margin: 20px">暂无数据</h1>
  </div>
</template>

<script>
import { getDicts } from '@/api/mian.js'
import { getInvitationList } from '@/api/招投标'
export default {
  data () {
    return {
      xiangmuList: [],
      deptId: sessionStorage.getItem('deptId'),
      listTotal: 0,
      pageNo: 1,
      dicts: [],
    }
  },
  created () {
    this.deptId = sessionStorage.getItem('deptId')
    this.requestList()
  },
  mounted () {
    getDicts('invest_type').then((res) => {
      this.dicts = res.data.data
    })
  },
  computed: {},
  watch: {},
  methods: {
    // 跳转到招投标项目详情页面
    toJingjia (i) {
      this.$router.push({ name: '招投标详情', query: { id: i } })
    },
    requestList () {
      let data = {
        pageNum: this.pageNo,
        pageSize: 8,
        deptId: this.deptId,
      }
      getInvitationList(data).then((res) => {
        console.log('招投标', res)
        this.xiangmuList = res.data.rows
        this.listTotal = res.data.total
      })
    },
    prevClick () {
      this.pageNo--
      this.requestList()
    },
    nextClick () {
      this.pageNo++
      this.requestList()
    },
    currentChange (i) {
      this.pageNo = i
      this.requestList()
    },
  },
}
</script>

<style scoped>
p {
  margin: 0;
}

a {
  text-decoration: none;
}

.root {
  /* min-height: 1180px; */
  width: 100%;
  /* min-height: 599px; */
  height: 500px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
  min-height: 555px;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 61px 0 37px;
  /* width: 1174px; */
  height: 80px;
  color: #2187ff;
  border-bottom: 1px solid #6681ea;
}

.mode > span {
  display: block;
  width: auto;
  height: 50px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  padding-left: 5px;
  border-left: #6681ea 6px solid;
  line-height: 50px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #6681ea;
  line-height: 80px;
}

.table {
  width: 100%;
}

.table tr {
  cursor: pointer;
}

.first_tr {
  width: 100%;
  height: 75px;
}

.first_tr th {
  height: 75px;

  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 75px;
}

td {
  max-width: 254px;
  height: 51px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 51px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
